module.exports = __webpack_public_path__ + "static/media/blank-face-lp.009e7067.jpg";